module.exports = __webpack_public_path__ + "img/acrobata-performer.a6541a5f.jpg";